import React, { createElement, useEffect, useState } from 'react';
import { Cascader, Form, Col } from 'antd';
import cls from 'classnames/bind';
import style from './index.module.scss';
import { generateRules } from '../../../utils';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { getDeptTree } from '../../../api/form';
const cx = cls.bind(style);
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const displayRender = (labels) => labels[labels.length - 1];
const FormOrganizationalTree = (props, ref) => {
    const { title, __id, rules, status, span, column, ...other } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [rule, setRule] = useState([]);
    useEffect(() => {
        try {
            setRule(generateRules(rules, 'array'));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('校验规则初始化出错,检查配置或更新组件');
        }
    }, [rules]);
    const [ops, setOps] = useState([]);
    useEffect(() => {
        setError(false);
        try {
            getDeptTree().then((res) => {
                setOps(res.data);
            });
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('选项初始化出错,检查配置或更新组件');
        }
    }, []);
    const eventEmit = (val) => {
        window.postMessage({ type: 'organizationalTree:change', data: val }, '*');
    };
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '级联复选', name: __id || props.componentId, rules: rule },
                createElement(Cascader, Object.assign({ disabled: status === 'readonly' || urlParams.get('edit') === '3' }, other, { displayRender: displayRender, multiple: true, options: ops, showSearch: true }))))))));
};
export default React.forwardRef(FormOrganizationalTree);
